/**
 * @fileoverview Textarea - Multi-line text input component
 *
 * Purpose: Accessible multi-line text input for longer content
 * Dependencies: None (native HTML textarea extended)
 * Used by: Forms requiring paragraph input, comments, descriptions
 *
 * Features:
 * - Minimum height of 80px (customizable)
 * - Auto-resize support
 * - Focus ring indicators
 * - Disabled state styling
 * - Placeholder styling
 * - Extends all native textarea HTML attributes
 *
 * @example
 * <Textarea placeholder="Enter your message..." />
 *
 * @example
 * // With custom height
 * <Textarea className="min-h-[120px]" placeholder="Longer content..." />
 *
 * @example
 * // Disabled
 * <Textarea disabled placeholder="Cannot edit" />
 */

import * as React from "react";

import { cn } from "@/utils/misc";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
